export enum AmplitudeEvents {
  SHOW_MOBILE_WEB_TAKEOVER = 'show-mobile-web-takeover',
  CLOSE_MOBILE_WEB_TAKEOVER = 'close-mobile-web-takeover',
  SELECT_DOWNLOAD_MOBILE_WEB_TAKEOVER = 'select-download-mobile-web-takeover',
  CLICK_NAV_OPEN_CLOSE_BUTTON = 'click-nav-open-close-button',
  CLICK_WORKPLACE_NAV_ITEM = 'click-workplace-nav-item',
  CLICK_SPACE_MANAGEMENT_NAV_ITEM = 'click-space-management-nav-item',
  CLICK_SET_HOMEPAGE = 'click-set-homepage',
  CLICK_GETTING_STARTED_NAV = 'click-getting-started-nav',
}
